import React from "react";
import { StyleSheet, View } from "react-native";
import { NavigationProp, ParamListBase, useRoute } from "@react-navigation/native";

import api from "src/util/apiNew";
import { closeTab } from "src/util/linking";
import { kStyleConst } from "src/kStyle";
import { LogoSmall, PdArrowLeft, PdArrowRight, PdShopify } from "src/components/Icons";
import { PdText } from "src/components/layout";
import { kColors } from "src/kColors";
import { PdButton, PdButtonLabel } from "src/components/forms/button";

type tShopifyOauthParams = {
  code: string;
  timestamp: string;
  state: string;
  shop: string;
  host?: string;
  hmac?: string;
};

type tShopifyAuthenticationParams = {
  params: tShopifyOauthParams;
  key: string;
  name: string;
};

const P104_ShopifyAuthentication: React.FC<{ navigation: NavigationProp<ParamListBase> }> = ({ navigation }) => {
  const route = useRoute<tShopifyAuthenticationParams>();
  const [isError, setError] = React.useState(false);

  const closeOrRedirect = React.useCallback(() => {
    closeTab();
    navigation.navigate("/");
  }, [navigation]);

  React.useEffect(() => {
    (async () => {
      if (route.params && route.params.code && route.params.timestamp && route.params.state && route.params.shop) {
        setTimeout(async () => {
          try {
            await api.put("shopify/auth", {
              code: route.params.code,
              timestamp: route.params.timestamp,
              state: route.params.state,
              shop: route.params.shop,
              host: route.params.host,
              hmac: route.params.hmac,
            });
            closeOrRedirect();
          } catch (er) {
            setError(true);
          }
        }, 2000);
      } else {
        navigation.navigate("/");
      }
    })();
  }, [closeOrRedirect, navigation, route.params]);

  return (
    <View style={[styles.flex1, styles.alignCenter, styles.justifyCenter, styles.bgWhite, styles.p10]}>
      <View style={[styles.flexRow, styles.alignCenter, styles.justifyCenter, styles.widthFull, styles.mb4]}>
        <PdShopify style={styles.heightLg} />
        <View style={styles.mx2}>
          <PdArrowLeft style={styles.heightXxs} />
          <PdArrowRight style={styles.heightXxs} />
        </View>
        <LogoSmall style={styles.heightLg} />
      </View>
      {isError ? (
        <View>
          <PdText style={[styles.textCenter, styles.mb4]}>
            An error occured. Please contact support or try again later.
          </PdText>
          <PdButton onPress={closeOrRedirect}>
            <PdButtonLabel>Close</PdButtonLabel>
          </PdButton>
        </View>
      ) : (
        <PdText style={styles.textCenter}>Connecting...</PdText>
      )}
    </View>
  );
};

export const P104 = React.memo(P104_ShopifyAuthentication);

const styles = StyleSheet.create({
  alignCenter: {
    alignItems: "center",
  },
  bgWhite: {
    backgroundColor: kColors.white,
  },
  flex1: {
    flex: 1,
  },
  flexRow: {
    flexDirection: "row",
  },
  heightLg: {
    height: 50,
  },
  heightXxs: {
    height: 7,
  },
  justifyCenter: {
    justifyContent: "center",
  },
  mb4: {
    marginBottom: 4 * kStyleConst.kSpacing,
  },
  mx2: {
    marginHorizontal: 2 * kStyleConst.kSpacing,
  },
  p10: {
    padding: 10 * kStyleConst.kSpacing,
  },
  textCenter: {
    textAlign: "center",
  },
  widthFull: {
    width: "100%",
  },
});
